import React, { HTMLAttributes } from 'react';

const Bubble: React.FC<HTMLAttributes<HTMLDivElement>> = (props) => {

  return (
    <span style={{
      fontWeight: 700, background: '#212529', display: 'inline-block', paddingTop: 13,
      height: 56, width: 56, borderRadius: 30, color: '#fff', fontSize: 28, overflow: 'hidden', textAlign: 'center'
    }}>
      {props.children}
    </span>
  )
}

export default Bubble;